import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import * as S from './CompanyInfo.styles';
import IconSelector from '@ibibo/icon-selector';
import {companyInfoSelector, setGccUserSetting} from '@ibibo/myaccount-reducer';
import Modal, {useModal} from '../../../../../../../hotels-dweb/src/shared/components/Modal';
import UpdateDetailsForm from '../../../common/Form/UpdateDetailsForm/UpdateDetailsForm';
import {updateUserDetailsAction, updateGccUserDetailsAction} from 'user-reducer/src';

const CompanyInfo = ({onEditClick}) => {
  const dispatch = useDispatch();
  const companyInfo = useSelector(companyInfoSelector);
  const maxWidth = (function() {
    if (!companyInfo || !Object.keys(companyInfo).length) {
      return 100;
    }
    let maxCount = 0;
    companyInfo?.key_list.map((item, key) => {
      let count = 0;

      if (companyInfo[item]?.key) {
        count += 1;
      }
      if (companyInfo[item]?.value) {
        count += 1;
      }
      if (companyInfo[item]?.statusMessage) {
        count += 1;
      }
      if (companyInfo[item]?.editablePlaceholder) {
        count += 1;
      }

      if (count > maxCount) {
        maxCount = count;
      }
    });

    return `${parseInt(`${100 / maxCount}`)}%`;
  })();
  const {isModalOpen, openModal, closeModal} = useModal();

  const [openModalFlag, setOpenModalFlag] = useState(false);
  const [modalData, setModalData] = useState({});
  const [popupType, setPopupType] = useState('');
  const [currentModalRow, setCurrentModalRow] = useState('');
  const [communicationAddress, setCommunicationAddress] = useState('');
  const errorsInitialState = {
    formSubmissionError: '',
    inputBoxError: '',
  };
  const [error, setError] = useState(errorsInitialState);

  const modalClickHandler = (data, popupClicked, rowItem) => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
    setModalData(data);
    setCurrentModalRow(rowItem);
    setPopupType(popupClicked);
    setCurrentModalRow(rowItem);
  };

  const popupSuccessCallback = resp => {
    setPopupType(resp?.data?.POPUP_TYPE);
    setCommunicationAddress(resp?.data);
    setError(errorsInitialState);
    setOpenModalFlag(false);
    dispatch(updateGccUserDetailsAction({...resp, businessProfile: resp?.data?.business_profile}));
  };

  const popupErrorCallback = err => {
    setError({...err, formSubmissionError: err.message});
  };

  const closeFormModal = () => {
    setOpenModalFlag(openModalFlag => !openModalFlag);
  };

  const handleButtonClick = data => {
    if (data?.type == 'EXTERNAL_LINK') {
      window.open(data?.external_url, '_blank');
    }
  };

  return (
    <S.ProfileMainWrap>
      <S.ProfileInnerWrap>
        <S.ProfileHeadOuterWrap>
          <S.ProfileHeadInnerWrap>
            <S.HeadMainText>{companyInfo?.heading}</S.HeadMainText>
            <S.HeadSubText>{companyInfo?.sub_heading}</S.HeadSubText>
          </S.ProfileHeadInnerWrap>
          {companyInfo?.is_root_level_editable && (
            <S.HeaderEditTag
              onClick={e =>
                modalClickHandler(
                  companyInfo[companyInfo?.POPUP_TYPE],
                  companyInfo?.POPUP_TYPE,
                  companyInfo[companyInfo?.POPUP_TYPE],
                )
              }
            >
              <IconSelector iconKey="edit" />
              <S.EditText>Edit</S.EditText>
            </S.HeaderEditTag>
          )}
        </S.ProfileHeadOuterWrap>
        {companyInfo?.key_list?.length &&
          companyInfo?.key_list.map((item, key) => {
            return companyInfo[item]?.component === 'BUTTON' ? (
              <>
                <S.ProfileInfoOuterWrap key={key}>
                  <S.ProfileInfoInnerWrap>
                    <S.InfoTitleWrap width={maxWidth}>
                      <S.TitleText>{companyInfo[item]?.key}</S.TitleText>
                    </S.InfoTitleWrap>
                    <S.InfoActionWrap width={maxWidth}>
                      <S.EditableText onClick={() => handleButtonClick(companyInfo[item])}>
                        {companyInfo[item]?.label}
                      </S.EditableText>
                    </S.InfoActionWrap>
                  </S.ProfileInfoInnerWrap>
                </S.ProfileInfoOuterWrap>
              </>
            ) : (
              companyInfo[item]?.value && (
                <S.ProfileInfoOuterWrap key={key}>
                  <S.ProfileInfoInnerWrap>
                    <S.InfoTitleWrap width={maxWidth}>
                      <S.TitleText>{companyInfo[item]?.key}</S.TitleText>
                    </S.InfoTitleWrap>
                    <S.InfoTextWrap width={maxWidth}>
                      <S.InfoText>{companyInfo[item]?.value}</S.InfoText>
                    </S.InfoTextWrap>
                    {companyInfo?.[item]?.statusMessage && (
                      <S.InfoStatusWrap width={maxWidth}>
                        <S.TitleText color={companyInfo[item]?.statusMessageTextColor}>
                          {companyInfo[item].statusMessage}
                        </S.TitleText>
                      </S.InfoStatusWrap>
                    )}
                    {companyInfo[item]?.editablePlaceholder && (
                      <S.InfoActionWrap width={maxWidth}>
                        <S.EditableText
                          color={companyInfo[item]?.editableTextColor}
                          onClick={() => {
                            if (companyInfo[item]?.action) {
                              onEditClick(companyInfo[item].action);
                            }
                          }}
                        >
                          {companyInfo[item]?.editablePlaceholder}
                        </S.EditableText>
                      </S.InfoActionWrap>
                    )}
                    {companyInfo[item]?.component == 'BUTTON' && (
                      <S.InfoActionWrap width={maxWidth}>
                        <S.EditableText onClick={() => handleButtonClick(companyInfo[item])}>
                          {companyInfo[item]?.label}
                        </S.EditableText>
                      </S.InfoActionWrap>
                    )}
                  </S.ProfileInfoInnerWrap>
                </S.ProfileInfoOuterWrap>
              )
            );
          })}
      </S.ProfileInnerWrap>
      {openModalFlag && (
        <Modal
          isOpen={openModalFlag}
          closeModal={closeFormModal}
          hideCloseButton={true}
          modalStyles={{
            width: '60rem',
          }}
        >
          (
          <UpdateDetailsForm
            {...modalData}
            successCallback={popupSuccessCallback}
            errorCallback={popupErrorCallback}
            errorMessages={error}
            closeModal={closeFormModal}
          />
          )
        </Modal>
      )}
    </S.ProfileMainWrap>
  );
};

export default CompanyInfo;
